import { Box, Grid } from '@mui/material';
import { useApp } from '../../Contexts/AppProvider';

const Header: React.FC = () => {
  const {config} = useApp();
  
  return (
    <Box>
      <Grid container spacing={2} sx={{mt: 0}}>
          {config?.assets?.logos && (
          <Grid item xl={12} lg={12} md={12} xs={12} sx={{lineHeight: 0}}>
            <img
              alt={config?.assets?.logos?.name || 'logos'}
              style={{
                position: 'relative',
                width: '100%',
                borderRadius: 15
              }}
              src={`${config?.assets?.logos.src}`}
            />
          </Grid>
          )}
          {config?.assets?.slogan && (
            <Grid item xl={12} lg={12} md={12} xs={12} sx={{lineHeight: 0}}>
              <img
                alt={config?.assets?.slogan?.name || 'slogan'}
                style={{
                  position: 'relative',
                  width: '100%',
                  borderRadius: 15
                }}
                src={`${config?.assets?.slogan?.src}`}
              />
            </Grid>
          )}
      </Grid>
    </Box>
  );
}

export default Header;